import apiHttpClient from "./ApiHttpService";

export default class VersionService {
  getVersionInfo() {
    return apiHttpClient.get(`trs/mobile/Version/getTrsVersion`);
  }
}
